const initialState = {
    relatorio: undefined,
    
};

export const relatorioAction = {

}
